import { type AUTOZONE_VARIABILITY_LEVEL } from "../types";

export function getColorForNDVIValue(value: number): string {
  const colorMap: any = {
    0.0: "#8F120B",
    0.05: "#BF3A28",
    0.1: "#C64F26",
    0.15: "#BF281B",
    0.2: "#E93324",
    0.25: "#FF3E1F",
    0.3: "#FF7425",
    0.35: "#FF9863",
    0.4: "#DEB048",
    0.45: "#FFBC72",
    0.5: "#FFC71D",
    0.55: "#FFDB8C",
    0.6: "#FFEE33",
    0.65: "#CEE334",
    0.7: "#A7CF7F",
    0.75: "#6DC72D",
    0.8: "#4DA825",
    0.85: "#40D265",
    0.9: "#3FF11F",
    0.95: "#006515",
    1.0: "#073010",
  };

  value = Math.max(0, Math.min(1, value));

  const thresholds = Object.keys(colorMap)
    .map(Number)
    .sort((a, b) => b - a);
  const matchingThreshold = thresholds.find((threshold) => value >= threshold);

  return matchingThreshold !== undefined
    ? colorMap[matchingThreshold]
    : "#000000"; // Default color if no match
}

export function getVariabilityTagType(
  value: number
): AUTOZONE_VARIABILITY_LEVEL {
  value = Math.max(0, Math.min(1, value));

  if (value >= 0.65) {
    return "HIGH";
  } else if (value >= 0.6) {
    return "MEDIUM";
  } else {
    return "LOW";
  }
}

export function getDefaultColorPaletteValue(
  position: number,
  numberOfZones: number
): string {
  // Ensure the number of zones is between 1 and 10
  numberOfZones = Math.max(1, Math.min(10, numberOfZones));

  const colorSchemes = {
    1: ["#9DC72D"],
    2: ["#FF3E1F", "#9DC72D"],
    3: ["#FF3E1F", "#F8C71D", "#9DC72D"],
    4: ["#FF3E1F", "#F8C71D", "#CDE334", "#9DC72D"],
    5: ["#FF3E1F", "#FF9863", "#F8C71D", "#CDE334", "#9DC72D"],
    6: ["#FF3E1F", "#FF9863", "#E7BC72", "#F8C71D", "#CDE334", "#9DC72D"],
    7: [
      "#FF3E1F",
      "#FF9863",
      "#E7BC72",
      "#F8C71D",
      "#CDE334",
      "#9DC72D",
      "#4D9265",
    ],
    8: [
      "#BF281B",
      "#FF3E1F",
      "#FF9863",
      "#E7BC72",
      "#F8C71D",
      "#CDE334",
      "#9DC72D",
      "#4D9265",
    ],
    9: [
      "#BF281B",
      "#FF3E1F",
      "#FF9863",
      "#E7BC72",
      "#F8C71D",
      "#CDE334",
      "#9DC72D",
      "#4D9265",
      "#006515",
    ],
    10: [
      "#8F3A2E",
      "#BF281B",
      "#FF3E1F",
      "#FF9863",
      "#E7BC72",
      "#F8C71D",
      "#CDE334",
      "#9DC72D",
      "#4D9265",
      "#006515",
    ],
  };

  const selectedScheme =
    colorSchemes[numberOfZones as keyof typeof colorSchemes];

  // Normalize the value to be between 0 and 1
  // value = Math.max(0, Math.min(1, value));

  // Calculate which color index this value corresponds to
  // const index = Math.floor(value * numberOfZones);

  // Return the color at that index, or the last color if the index is out of bounds
  return selectedScheme[position];
}

export function getAccessibilityPaletteValue(
  position: number,
  numberOfZones: number
): string {
  // Ensure the number of zones is between 1 and 10
  numberOfZones = Math.max(1, Math.min(10, numberOfZones));

  const colorSchemes = {
    1: ["#B18041"],
    2: ["#B18041", "#A34F6D"],
    3: ["#B18041", "#E7BC72", "#A34F6D"],
    4: ["#B18041", "#E7BC72", "#A34F6D", "#C3708E"],
    5: ["#B18041", "#865719", "#E7BC72", "#A34F6D", "#C3708E"],
    6: ["#B18041", "#865719", "#E7BC72", "#C84F2B", "#A34F6D", "#C3708E"],
    7: [
      "#B18041",
      "#865719",
      "#E7BC72",
      "#C84F2B",
      "#A34F6D",
      "#C3708E",
      "#455588",
    ],
    8: [
      "#B18041",
      "#865719",
      "#E7BC72",
      "#C84F2B",
      "#8F3A2E",
      "#A34F6D",
      "#C3708E",
      "#455588",
    ],
    9: [
      "#B18041",
      "#865719",
      "#E7BC72",
      "#C84F2B",
      "#8F3A2E",
      "#A34F6D",
      "#C3708E",
      "#3675B2",
      "#455588",
    ],
    10: [
      "#B18041",
      "#865719",
      "#E7BC72",
      "#DE8D4B",
      "#C84F2B",
      "#8F3A2E",
      "#A34F6D",
      "#C3708E",
      "#3675B2",
      "#455588",
    ],
  };

  const selectedScheme =
    colorSchemes[numberOfZones as keyof typeof colorSchemes];

  // Normalize the value to be between 0 and 1
  // value = Math.max(0, Math.min(1, value));

  // Calculate which color index this value corresponds to
  // const index = Math.floor(value * numberOfZones);

  // Return the color at that index, or the last color if the index is out of bounds
  return selectedScheme[position];
}
